module.exports = __webpack_public_path__ + "img/photo_220630603_1.5b6b9fab.jpg";